module.exports = __webpack_public_path__ + "static/img/reviewAdopt.ec40e9e8.png";